/** The agent list frame's chrome. */
export default {
  noAgentsAssigned: "No agents assigned",
  statusActive: "Active",
  statusAvailable: "Available",
} as const;
